import { Component } from '@angular/core';

@Component({
  selector: 'app-installation-setup-content',
  templateUrl: './installation-setup-content.component.html',
  styleUrls: ['./installation-setup-content.component.scss'],
})
export class InstallationSetupContentComponent {}
